export default __webpack_public_path__ + "static/media/pankaj.5adfdb6d.png";